import { Button } from "@/elements"
import React from "react"
import { PortfolioEditModal, useEditPortfolio } from "./useEditPortfolio"
import { ReorderListIcon } from "@/icons/outline/ReorderListIcon"

interface Props {
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
}

const rightElement = () => <ReorderListIcon className="size-[20px] stroke-fg-2" />

export const ReorderProjectsFloatingCTA: React.FC<Props> = ({ editProfileMethods }) => {
  const onClick = () => {
    editProfileMethods?.setOpenModal(PortfolioEditModal.ReorderProjects)
  }

  if (!editProfileMethods?.isEditing) {
    return null
  }

  return (
    <div className="fixed bottom-10 left-1/2 z-20 -translate-x-1/2 md:pl-[96px] lg:pl-[225px]">
      <Button size="large" onClick={onClick} variant="white" floating RightElement={rightElement}>
        Reorder projects
      </Button>
    </div>
  )
}
